module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/Attendance-Leaves/monthly-leave-atten/monthly-leave-atten-grid/monthly-leave-atten-grid.component.css
// module id = ./src/app/hrms/Attendance-Leaves/monthly-leave-atten/monthly-leave-atten-grid/monthly-leave-atten-grid.component.css
// module chunks = main